import './index.less';
import i18n from './i18n.json';
import Service from './service';

const { Feature, meta, hook, event } = checkApp.core; //eslint-disable-line
const { Button, Tooltip, Loading } = checkApp.components;//eslint-disable-line
const { utils, aplus } = checkApp.common;//eslint-disable-line

const DOMAIN_MAX_LEN = 36;
const saleLink = '//yuming.aliyun.com/tdomain/orderConfirmdomain?domain=';
const ykjLink = '//wanwang.aliyun.com/nametrade/detail/online.html?oproductType=2&domainName=';

@meta('sale', ['service', 'request'], 2, i18n)
export default class SaleFeature extends Feature {

  @event('sale.inject')
  createService() {
    this.saleService = new Service(this);
  }

  startLoading() {
    this.setState({ loading: true, list: [] }, { scoped: true });
  }

  stopLoading() {
    this.setState({ loading: false }, { scoped: true });
  }

  @hook('checkBox.check')
  async check({ keyword }) {
    await this.startLoading();
    const rs = await this.saleService.search(keyword);
    const list = (rs && rs.data) || [];
    //console.log('list', list);
    await this.setState({ keyword, list }, { scoped: true });
    await this.stopLoading();
  }

  @hook('toolbar.isAvailable')
  isSale(item) {
    const { list = [] } = this.getState({ scoped: true });
    return list.some(i => i.domainName == item.domain);
  }

  @hook('checkItem.renderLabel')
  renderLabel(item, prevResult) {
    if (!this.isSale(item)) return prevResult;
    return <a key={item.domain}
      target="_blank" href={`${ykjLink}${item.domain}`}
      className={'label label-warning hidden-xs hidden-sm'}>
      一口价域名售卖中
      <Tooltip trigger={
        <i className="glyphicon glyphicon-question-sign"></i>
      }>在域名交易市场直接按照在线公示价格支付购买</Tooltip>
    </a>;
  }

  @hook('checkItem.renderButton')
  renderButton(item, prevResult) {
    if (!this.isSale(item)) return prevResult;
    return <a target="_blank" href={`${ykjLink}${item.domain}`}
      className={'btn btn-primary btn-lg shopping-cart-hide-prevent hollow'}>
      立即购买
    </a>;
  }

  /**
   * 渲染推荐域名列表
   * @param {Array<object>} list 域名列表
   * @returns {object} 域名列表 dom
   */
  renderList(list) {
    return <ul className="check-list">
      {list.map(item => (
        <li className="check-item" key={item.name}>
          <span className="domain">
            {utils.short(item.domainName, DOMAIN_MAX_LEN)}
          </span>
          <a href={`${saleLink}${item.domainName}`}
            target="_blank"
            className={
              'btn btn-primary pull-right hollow shopping-cart-hide-prevent'
            }>
            立即购买
          </a>
          <span className="price">
            ￥{item.price || 0}/{this.locale('year')}
          </span>
        </li>
      ))}
    </ul>;
  }

  /**
   * 渲染列表长度为 0 时的信息
   * @param {boolean} loading 是否为 Loading 状态
   * @returns {object} dom
   */
  renderEmpty(loading) {
    return <div className="empty">
      {loading ? this.locale('loading') : this.locale('empty')}
    </div>;
  }

  /**
   * 渲染右侧面板
   * @param {object} state 状态对象
   * @returns {objecg} 面板 dom
   */
  @hook('main.renderMainPanel')
  renderMainPanel() {
    const { list = [], loading, keyword = '' } =
      this.getState({ scoped: true });
    return <div key={this.id} className="panel side recommend">
      <div className="panel-heading">
        <span>{this.locale('title')}</span>
        <a className="pull-right refresh"
          target="_blank"
          href={`//wanwang.aliyun.com/nametrade/?key=${keyword}`}>
          查看更多
        </a>
      </div>
      {list && list.length > 0 ?
        this.renderList(list) :
        this.renderEmpty(loading)}
    </div>;
  }

}


// WEBPACK FOOTER //
// ./src/sale/index.js